import type { ChartValidationRequest, ChartValidationResult } from '../models/chartValidation.types'

export interface ChartValidationTransport {
  validate: (
    request: ChartValidationRequest,
    signal?: AbortSignal,
  ) => Promise<ChartValidationResult>
}

/** Injectable service seam used when a saved/dashboard chart candidate must be server-validated. */
export function validateChartContract(
  request: ChartValidationRequest,
  transport: ChartValidationTransport,
  signal?: AbortSignal,
): Promise<ChartValidationResult> {
  return transport.validate(request, signal)
}
